module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.error) ? _c('div', {
    staticClass: "notification is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.error.message)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.successMsg) ? _c('div', {
    staticClass: "notification is-success"
  }, [_vm._v(_vm._s(_vm.successMsg))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comment.content),
      expression: "comment.content"
    }],
    ref: "commentContent",
    staticClass: "textarea",
    attrs: {
      "placeholder": "Say something! Add your comment here...",
      "required": ""
    },
    domProps: {
      "value": (_vm.comment.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comment.content = $event.target.value
      }
    }
  })]), _vm._v(" "), (!_vm.commenterSaved) ? _c('div', {
    staticClass: "field is-grouped"
  }, [_c('div', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comment.name),
      expression: "comment.name"
    }],
    ref: "commentName",
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Your Name",
      "required": ""
    },
    domProps: {
      "value": (_vm.comment.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comment.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comment.email),
      expression: "comment.email"
    }],
    ref: "commentEmail",
    staticClass: "input",
    attrs: {
      "type": "email",
      "placeholder": "Your Email Address",
      "required": ""
    },
    domProps: {
      "value": (_vm.comment.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comment.email = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.commenterSaved) ? _c('div', {
    staticClass: "field"
  }, [_vm._v("\n    Commenting as: " + _vm._s(_vm.comment.name) + ". "), _c('button', {
    on: {
      "click": _vm.clearCommenterFromLocalStorage
    }
  }, [_vm._v("I'm not " + _vm._s(_vm.comment.name))])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "has-text-right"
  }, [_c('button', {
    staticClass: "button button-underline",
    on: {
      "click": _vm.submitComment
    }
  }, [_vm._v("Submit")]), _vm._v(" "), (_vm.$parent.replying) ? _c('button', {
    staticClass: "button button-underline cancel",
    on: {
      "click": _vm.$parent.toggleReply
    }
  }, [_vm._v("Cancel")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-effe2412"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/CommentForm.vue
// module id = 804
// module chunks = 1